import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="footer-content">
                {/* <p>
                    Developed by{' '}
                    <a
                        href="https://frothyhog.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="brand"
                    >
                        FrothyHog Studio
                    </a>
                </p> */}
                <p>
                    Hololive OCG and related trademarks are property of Cover Corp. 
                    Akaina is not affiliated with Cover Corp or its subsidiaries.
                </p>
                <p>
                    This website is for informational and entertainment purposes only. All card images, translations, and data 
                    are sourced for fair use and are the property of their respective copyright holders.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
